import i18n from '../../../core';

const currentI18NPreference = localStorage.getItem('user_i18n_preference');
const sharedStrings = i18n.en_GB;

export default sharedStrings;
